<template>
  <div class="home">
    <BackgroundVideoParallax
      class="large left"
      :data="data?.background_image"
    />
    <HowItWorks />
    <AppShowcase :buttons="data?.rotatingWords?.buttons" />
    <Reassurances :data="data?.reassurances" />
    <Testimonials :data="data?.testimonials" />
    <FairQuestions />
    <RotatingWords
      id="get-the-app"
      :data="data?.rotatingWords"
    />
  </div>
</template>

<script>
import { apollo } from '@/mixins'

import BackgroundVideoParallax from '@/components/Images/BackgroundVideoParallax.vue'
import HowItWorks from '@/components/Sections/HowItWorks.vue'
import AppShowcase from '@/components/Sections/AppShowcase.vue'
import Reassurances from '@/components/Images/Reassurances.vue'
import Testimonials from '@/components/Images/Testimonials.vue'
import FairQuestions from '@/components/Sections/FairQuestions.vue'
import RotatingWords from '@/components/Text/RotatingWords.vue'

export default {
  name: 'HomeView',
  mixins: [apollo],
  components: {
    BackgroundVideoParallax,
    HowItWorks,
    AppShowcase,
    Reassurances,
    Testimonials,
    FairQuestions,
    RotatingWords,
  },
  data() {
    return {
      apolloId: 'homepage'
    }
  },
}
</script>
